import { render, staticRenderFns } from "./feed-list-item.vue?vue&type=template&id=8e3f66f2&scoped=true&"
import script from "./feed-list-item.vue?vue&type=script&lang=js&"
export * from "./feed-list-item.vue?vue&type=script&lang=js&"
import style0 from "./feed-list-item.vue?vue&type=style&index=0&id=8e3f66f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3f66f2",
  null
  
)

export default component.exports